module.exports = {"320923001":"阜城街道","320923002":"吴滩街道","320923003":"花园街道","320923004":"金沙湖街道","320923100":"沟墩镇","320923101":"陈良镇","320923102":"三灶镇","320923103":"郭墅镇","320923104":"新沟镇","320923105":"陈集镇","320923106":"羊寨镇","320923107":"芦蒲镇","320923108":"板湖镇","320923109":"东沟镇","320923110":"益林镇","320923111":"古河镇","320923112":"罗桥镇","320923402":"现代服务业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320923.json
// module id = 1009
// module chunks = 0